<script lang="ts" setup>
import { onMounted } from "vue";

import RecentlyViewed from "./components/RecentlyViewed.vue";
import WorkflowTraffic from "./components/WorkflowTraffic.vue";
import WorkflowErrors from "./components/WorkflowErrors.vue";
import UsageSummary from "./components/UsageSummary.vue";
import WorkflowStatus from "./components/WorkflowStatus.vue";
import PanelGrid from "@/views/shared/components/PanelGrid.vue";
import PanelCard from "@/views/shared/components/PanelCard.vue";

onMounted(() => {});
</script>

<template>
  <main class="dashboard">
    <PanelGrid>
      <h1 class="visually-hidden">Dashboard</h1>
      <PanelCard>
        <recently-viewed></recently-viewed>
      </PanelCard>
        <PanelCard>
        <workflow-traffic></workflow-traffic>
      </PanelCard>
      <PanelCard>
        <workflow-errors></workflow-errors>
      </PanelCard>
      <PanelCard>
        <usage-summary></usage-summary>
      </PanelCard>
      <PanelCard>
        <workflow-status></workflow-status>
      </PanelCard>
    </PanelGrid>
  </main>
</template>

<style lang="scss" scoped>
@import 'bootstrap/scss/functions';
@import 'bootstrap/scss/variables';
@import 'bootstrap/scss/mixins';

// PanelGrid zeroes its container padding below lg, so its cards sit flush to the
// screen edge on mobile. Unlike most pages, the dashboard panels have no inner
// gutter/PageHeader to inset their content, so the flush edge is visible. Re-add a
// small gap here — scoped to .dashboard so no other page is affected. The top
// padding matters most: the row's gy-3 only spaces panels from each other, so
// without it the first panel butts against the page header with no gap above it.
.dashboard :deep(.panel-grid > .container-fluid) {
  @include media-breakpoint-down(lg) {
    padding: 0.75rem;
  }
}
</style>
